import React from "react";

import { DashboardContent } from "../components";

export const Dashboard: React.FC = () => {
    return <DashboardContent />;
};